import Cookies from 'js-cookie';

import { SUPPORTED_LANGUAGES } from '@/utils/constants';
import type { SupportedLanguage } from '@/utils/globalTypes';

import type { GetServerSidePropsContext } from 'next';

function getLangClient(): SupportedLanguage {
  const raw = Cookies.get('lang');
  const fallback: SupportedLanguage = 'en';

  if (raw && (SUPPORTED_LANGUAGES as readonly string[]).includes(raw)) {
    return raw as SupportedLanguage;
  }

  return fallback;
}

function getLangSSR(ctx: GetServerSidePropsContext): SupportedLanguage {
  const raw = ctx.req.cookies.lang;
  return raw === 'nl' || raw === 'de' || raw === 'en' || raw === 'es' ? raw : 'en';
}

export function getCurrentLang(ctx?: GetServerSidePropsContext): SupportedLanguage {
  // Server path
  if (ctx?.req) return getLangSSR(ctx);

  // Client path
  if (typeof window !== 'undefined') return getLangClient();

  // Fallback (should rarely happen)
  return 'en';
}
